import React from 'react'
import { useTranslation } from 'react-i18next'
import {
  Table,
  TableBody,
  TableRow,
  TableCell,
  TableHead,
} from '@material-ui/core'
import { formatLength } from '../../../util/formatters'
import { TableHeaderTitleCell } from '../report/TableHeaderTitleCell'
import { TableValueCell } from '../../common/TableValueCell'
import { TableTitleCell } from '../../common/TableTitleCell'
import { EditableText } from '../../form/EditableText'
import type { BoreholeFieldContainerInput } from '../../../generated/graphql'
import type { BoreholeFieldContainerFragment } from '../../../borehole-field-container/borehole-field-confirmation-validator'

export type BoreholeFieldDefinitionsProps = {
  container: BoreholeFieldContainerFragment
  updateContainer: (input: BoreholeFieldContainerInput) => Promise<void>
}

export function BoreholeFieldDefinitions({
  container,
  updateContainer,
}: BoreholeFieldDefinitionsProps): React.ReactElement {
  const { t } = useTranslation()

  const handleHoleCountChange = async (value: string) => {
    await updateContainer({ holeCount: Number(value) })
  }
  const handleHoleDepthChange = async (value: string) => {
    await updateContainer({ holeDepth: Number(value) })
  }

  const totalDepth = container.holeCount * container.holeDepth

  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableHeaderTitleCell
            title={t('boreholeField.holeDefinitions')}
            colSpan={2}
          />
        </TableRow>
      </TableHead>
      <TableBody>
        <TableRow>
          <TableTitleCell title={t('boreholeField.holeCount')} />
          <TableCell>
            <EditableText
              value={container.holeCount.toString()}
              onChange={handleHoleCountChange}
              unit="kpl"
            />
          </TableCell>
        </TableRow>
        <TableRow>
          <TableTitleCell title={t('boreholeField.holeDepth')} />
          <TableCell>
            <EditableText
              value={container.holeDepth.toString()}
              onChange={handleHoleDepthChange}
              unit="m"
            />
          </TableCell>
        </TableRow>
        <TableRow>
          <TableTitleCell title={t('boreholeField.totalDepth')} highlight />
          <TableValueCell value={formatLength(totalDepth)} highlight />
        </TableRow>
      </TableBody>
    </Table>
  )
}
